import { render } from "./BaseBox.vue?vue&type=template&id=7c407bd8&scoped=true&ts=true"
import script from "./BaseBox.vue?vue&type=script&lang=ts"
export * from "./BaseBox.vue?vue&type=script&lang=ts"

import "./BaseBox.vue?vue&type=style&index=0&id=7c407bd8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c407bd8"]])

export default __exports__